/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/verify-email`,
    // @ts-ignore for sm-axios
    urlTemplate: '/verify-email',
    method: 'PATCH',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * verify the email against the token
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    token: string
    email: string
  }
}

export interface Response {
  homepageUrl: string
}

